// extracted by mini-css-extract-plugin
export var buttons = "bL_cG";
export var left = "bL_bL";
export var media = "bL_hv";
export var right = "bL_bX";
export var section = "bL_d";
export var selected = "bL_bg";
export var signature = "bL_ht";
export var testimonial = "bL_hs";
export var text = "bL_cm";
export var textContainer = "bL_b1";
export var video = "bL_gL";